import moment from 'moment';

const CST_OFFSET = 8 * 60;

export function toCST(time: any): moment.Moment {
    if (time == null) {
        return moment().utcOffset(CST_OFFSET);
    }
    if (time instanceof Date || typeof time === 'number') {
        return moment(time).utcOffset(CST_OFFSET);
    }
    const str = String(time);
    if (/[Z]\s*$|[+-]\d{2}:?\d{2}$/.test(str)) {
        return moment.utc(time).utcOffset(CST_OFFSET);
    }
    return moment(time).utcOffset(CST_OFFSET, true);
}

export function getYear(time: any): number {
    return toCST(time).year();
}

export function getMonth(time: any): number {
    return toCST(time).month() + 1;
}

export function getDay(time: any): number {
    return toCST(time).date();
}

export function formatChinese(time: any): string {
    const m = toCST(time);
    return `${m.year()}年${m.month() + 1}月${m.date()}日`;
}

export function formatChineseNoYear(time: any): string {
    const m = toCST(time);
    return `${m.month() + 1}月${m.date()}日`;
}

export function formatEnglish(time: any): string {
    return toCST(time).format('MMMM D');
}

export function formatEnglishFull(time: any): string {
    return toCST(time).format('MMMM D, YYYY');
}

export function formatDateTime(time: any): string {
    return toCST(time).format('YYYY-MM-DD HH:mm:ss');
}

export function formatDate(time: any): string {
    return toCST(time).format('YYYY-MM-DD');
}

export function getYearText(time: any, locale?: string): string {
    const year = getYear(time);
    return locale === 'zh-CN' ? `${year}年` : `${year}`;
}

export function getExamDateText(time: any, locale?: string): string {
    const m = toCST(time);
    if (locale === 'zh-CN') {
        return `${m.year()}年${m.month() + 1}月${m.date()}日`;
    }
    return `${m.month() + 1}/${m.date()}/${m.year()}`;
}
